import styles from "./Button.module.css"

const Button = (props) => {
  const { className, disabled, value, style = {}, onClick } = props;
  
  return (
    <>
      <button className={styles[className]} disabled={disabled} style={style} onClick={onClick} >
        {value}
      </button>
    </>
  );
};

export default Button;
